// @flow
import { isNil, last, head } from "ramda"

const currencySymbols = {
  USD: "$",
  CAD: "$",
  AUD: "$",
  NZD: "$",
  EUR: "€",
  JPY: "¥",
}

const specialCurrencies = [
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "JPY",
  "KMF",
  "KRW",
  "MGA",
  "PYG",
  "RWF",
  "UGX",
  "VND",
  "VUV",
  "XAF",
  "XOF",
  "XPF",
]

const getSymbol = (currency?: string) => {
  if (!currency || !currencySymbols[currency]) {
    return currencySymbols.USD
  }

  return currencySymbols[currency]
}

export const formatMoney = (
  m: ?number,
  fixed?: boolean,
  currency?: string,
): ?string => {
  if (isNil(m)) return undefined

  const isNatural = (m / 100) % 1 === 0
  const currencySymbol = getSymbol(currency)

  if ((fixed || !isNatural) && !specialCurrencies.includes(currency)) {
    return `${currencySymbol}${(m / 100).toFixed(2)}`
  }

  return `${currencySymbol}${m / 100}`
}

export const formatPricing = (pricing: number[], currency: string): ?string => {
  if (pricing.length === 1) return formatMoney(pricing[0], false, currency)
  return `${[last(pricing), head(pricing)]
    .map(x => formatMoney(x, false, currency))
    .join(" - ")} ${currency || "USD"}`
}



// WEBPACK FOOTER //
// ./src/data/units/money/formatters.js